import { DownloadButton } from '@anytag/shared-atoms';
import { ListWithPagination } from '@anytag/shared-molecules';
import { convertOrderToORDER, getOffset, getRestApiUrl, getValuableVariables } from '@anytag/shared-utils';
import { useDownloadFile, useParamsSearch } from '@anytag/shared-hooks';
import { SocialPostType, useAllInfluencerAccountPostsQuery } from '@anytag/graphql';
import {
  ProfilePostsCount,
  InfluencerXhsPostsList,
  InfluencerXhsPostsFilter,
  InfluencerXhsPostsSearchSchemaType
} from '@anytag/shared-organisms';
import { useInitialInfluencerPostsListWithName } from '../hooks';
import { getIsSponsoredPostForAPI } from './utils';

export const InfluencerXhsVideoPosts = () => {
  const { downloading, handleDownloadFile } = useDownloadFile();
  const { influencerId, mainSocialAccountId } = useInitialInfluencerPostsListWithName({
    title: 'appHeader.Video Post List',
    titleWithName: 'appHeader.VideoPostListWithAccountName'
  });
  const { page, limit, sort, filter, setSort, setFilter } = useParamsSearch<InfluencerXhsPostsSearchSchemaType>();

  const { data, loading } = useAllInfluencerAccountPostsQuery({
    skip: !influencerId || !mainSocialAccountId,
    variables: getValuableVariables({
      limit,
      socialPostType: SocialPostType.XHS,
      socialAccountId: mainSocialAccountId,
      isSponsoredPost: getIsSponsoredPostForAPI(filter.postType),
      keyword: filter.keyword,
      offset: getOffset(page, limit),
      isVideo: true,
      orderBy: { field: sort.field, order: convertOrderToORDER(sort.order) }
    })
  });

  const totalRecords = data?.allInfluencerAccountPostsCount?.totalNumber;

  return (
    <ListWithPagination pagination={{ totalRecords }}>
      <InfluencerXhsPostsFilter filter={filter} setFilter={setFilter} />

      <ProfilePostsCount count={totalRecords}>
        <DownloadButton
          loading={downloading}
          onClick={() =>
            handleDownloadFile({
              filenamePrefix: 'scraping_posts',
              url: getRestApiUrl(`influencer/social_post/${mainSocialAccountId}/${SocialPostType.XHS}/csv/`),
              params: {
                isVideo: 'true'
              }
            })
          }
        />
      </ProfilePostsCount>

      <InfluencerXhsPostsList
        sort={sort}
        setSort={setSort}
        loading={loading}
        influencerId={influencerId}
        totalRecords={totalRecords}
        socialPostType={SocialPostType.XHS}
        data={data?.allInfluencerAccountPosts || []}
      />
    </ListWithPagination>
  );
};
